import {Command} from 'substance'
import {Event} from '../../lib/constants/Event'

class SaveCommand extends Command {
    getCommandState() {
        return true
    }

    execute(params) {
        const {api} = params
        if (api.browser.isSupported()) {
            api.events.trigger(null, Event.USERACTION_SAVE)
        }
    }
}

export {SaveCommand}
